import { useMemo } from 'react';
import { Button, Card } from 'react-bootstrap';

import { CONFIG } from './config';
import { ES_RESOURCE_TYPE, OPEN_ACCESS, RESTRICTED_ACCESS } from './constants';
import { getAccessibilityStatus } from './utils/accessibility';
import { type DOI } from './utils/doi';

export function DOIDataAccess({ doi }: { doi: DOI }) {
  const investigationId = useMemo(() => {
    const regExp = new RegExp(/\/\w*-*[Ee][Ss][Rr][Ff]-[Ee][Ss]-(\d+)$/u);
    const res = regExp.exec(doi.doi);
    if (res) {
      return res[1];
    }
    return undefined;
  }, [doi]);

  const accessibilityStatus = useMemo(() => getAccessibilityStatus(doi), [doi]);

  const accessDataButtonText = useMemo(
    () =>
      accessibilityStatus === RESTRICTED_ACCESS
        ? 'Access data for experimental team'
        : 'Access data',
    [accessibilityStatus],
  );

  const dataUrl = useMemo(
    () =>
      doi.resourceType === ES_RESOURCE_TYPE
        ? CONFIG.DATA_ACCESS_LINK_INVESTIGATION.replace(
            ':id',
            investigationId || 'undefined',
          )
        : CONFIG.DATA_ACCESS_LINK_DOI.replace(':id', doi.doi),
    [doi, investigationId],
  );

  return (
    <Card className="h-100">
      <Card.Header className="p-2">Experimental data</Card.Header>
      <Card.Body className="p-2">
        {accessibilityStatus === OPEN_ACCESS && (
          <p className="mb-2">
            Data can be accessed by clicking on the link below:
          </p>
        )}
        {accessibilityStatus === RESTRICTED_ACCESS && (
          <p className="mb-2">
            Data is under embargo until <b>{doi.publicationYear}</b> but could
            be released earlier. Currently, it is only accessible to proposal
            team members.
          </p>
        )}
        <Button
          variant="primary"
          href={dataUrl}
          target="_blank"
          rel="noopener noreferrer"
          size="sm"
        >
          {accessDataButtonText}
        </Button>
      </Card.Body>
    </Card>
  );
}
